import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "driverSelect" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M3 11C3 6.02931 7.02931 2 12 2C16.9707 2 21 6.02931 21 11C21 15.9707 16.9707 20 12 20C10.4586 20 9.00773 19.6125 7.73946 18.9297L8.57645 16.8924L10.7431 19.1208C11.0318 19.4177 11.5 19.1889 11.5 18.7994V8.67742H13.1617C14.0192 8.67742 14.7595 9.14738 15.162 9.83871H18.5696C18.0177 6.70939 15.2854 4.32258 12 4.32258C8.71464 4.32258 5.98234 6.70939 5.43109 9.83871H8.69887L6.44084 12.1613H5.43036C5.48041 12.4448 5.54836 12.7222 5.633 12.9922L3.85096 14.8252C3.3051 13.6643 3 12.3678 3 11ZM4.40326 15.8282C4.81691 16.4777 5.31157 17.0705 5.87301 17.5926L6.59738 15.8282H4.40326ZM13.1613 14.4839V17.5696C15.9125 17.0841 18.0841 14.9125 18.5696 12.1613H14.9032L13.1613 14.4839Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M3.63278 15.0496C3.34598 15.3291 3.5576 15.8281 3.94528 15.8281H6.59738L5.2016 19.228C5.10438 19.4637 5.21548 19.7279 5.4377 19.8279L6.66683 20.3636C6.89595 20.4636 7.1529 20.3493 7.25013 20.1208L8.57645 16.8924L10.7431 19.1208C11.0318 19.4177 11.5 19.1888 11.5 18.7994V8.05747C11.5 7.64747 11.002 7.4476 10.7431 7.73607L3.63278 15.0496ZM9.6518 6.70669L2.56734 13.9937C1.33259 15.2264 2.23672 17.3281 3.94528 17.3281H4.36007L3.81494 18.656C3.81469 18.6566 3.81445 18.6572 3.8142 18.6578C3.81413 18.6579 3.81428 18.6576 3.8142 18.6578C3.40593 19.651 3.87132 20.768 4.82216 21.1958L4.83027 21.1995L6.06682 21.7384C6.06706 21.7385 6.06658 21.7383 6.06682 21.7384C7.1201 22.1976 8.23316 21.6419 8.63045 20.7079L8.63408 20.6994L9.09497 19.5775L9.66757 20.1665C10.2883 20.8048 11.1659 20.8906 11.8444 20.5858C12.4916 20.2951 13 19.6323 13 18.7994V8.05747C13 6.43959 10.9356 5.32062 9.6518 6.70669Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }